import { isEmpty } from 'lodash';

/**
 * To check whether the variable has a permitted value
 * eg: even for a boolean variable, undefined, null will be considered as false
 *     while the value 'false' is considered as true (assigned)
 * @param {*} value value to be checked
 * @returns whether the given value is unassigned
 */
export const isUnassigned = value => value === undefined || value === null;

/**
 * return object of query params
 * @param {String} opcoId opcoId
 * @param {String} adId federation id
 * @param {String} searchKey search term
 * @returns {Object} query params
 */
export const buildQueryParams = dictionary => {
    if (!dictionary) {
        return null;
    }
    const queries = {};

    for (const [key, value] of Object.entries(dictionary)) {
        if (key && value) {
            queries[key] = value;
        }
    }

    return isEmpty(queries) ? null : queries;
}